import Layout from "@components/layout/layout";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ConfirmedCompaniesView from "./ConfirmedCompaniesView";
import { BULK_LOGS_PATH, FROM_BULK_LOGS } from "../constants";
import type { BulkNavigationState, BulkSearchRootState } from "../types";

const ConfirmedCompaniesPage = () => {
  const history = useHistory();
  const { searchId } = useParams<{ searchId: string }>();
  const location = useLocation<BulkNavigationState | undefined>();
  const userDetails = useSelector((state: BulkSearchRootState) => state.userDetails);
  const currentUserPlan = userDetails?.creditDetails?.data?.[0]?.user_active_plan;

  return (
    <Layout type="companySearch" pageTitle="Bulk Company Search | Trademo Intel" setNotification={() => null}>
      <div className="tw-text-gray-900">
        <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-px-5 tw-py-4">
          <button type="button" onClick={() => history.push(location.state?.from === FROM_BULK_LOGS ? BULK_LOGS_PATH : "/company-search")} className="tw-flex tw-items-center tw-gap-1 tw-border-none tw-bg-transparent tw-p-0 tw-text-base tw-text-gray-max">
            <span className="material-symbols-outlined tw-font-semibold tw-text-2xl tw-leading-none">arrow_left_alt</span>
            Go back
          </button>
        </div>
        <ConfirmedCompaniesView searchId={searchId} currentUserPlan={currentUserPlan} />
      </div>
    </Layout>
  );
};

export default ConfirmedCompaniesPage;
